module.exports = __webpack_public_path__ + "static/media/whatsapp.1f8c25d2.svg";